import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { environment } from 'src/environments/environment';
import { IBasketItem, IBasketItemSearchRequest, ICreateBasketRequest, ISyncOfflineBasketRequest, ISyncOfflineBasketResponse, IUpdateBasketItemRequest } from '../models/basket';

@Injectable({
  providedIn: 'root'
})
export class BasketService {

  constructor(private http: HttpClient, private appnotificationService: AppNotificationService,) { }

  listBasketItems(request: IBasketItemSearchRequest){
    return this.http.post<IPagedResults<IBasketItem[]>>(
      `${environment.baseUrl}/v1/basketitems/searchbasketitems`,
      request
    )
  }

  addBasketItem(request : ICreateBasketRequest){
    return this.http.post<IBasketItem>(
      `${environment.baseUrl}/v1/basketitems/createbasketitem`,
      request
    )
  }

  syncOfflineBasket(request : ISyncOfflineBasketRequest){
    return this.http.post<ISyncOfflineBasketResponse>(
      `${environment.baseUrl}/v1/basketitems/syncOfflineBasket`,
      request
    )
  }

  deleteBasketItem(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/basketitems/deletebasketitem/${id}`
    )
  }

  updateBasketItem(request : IUpdateBasketItemRequest){
    return this.http.put<IBasketItem>(
      `${environment.baseUrl}/v1/basketitems/updatebasketitem/${request.id}`,
      request
    )
  }
}
